import { Component, OnInit } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { Router } from '@angular/router';
import { CourseService } from 'src/app/services/course.service';

@Component({
  selector: 'app-search-course-work',
  templateUrl: './search-course-work.component.html',
  styleUrls: ['./search-course-work.component.scss']
})
export class SearchCourseWorkComponent implements OnInit {
  allCourseWork: any[] = [];
  isCourseWorkAvailable: boolean = false;
  courseWorkList: any[];
  loader = false;
  assessmentTypes = [
    { name: 'Published', value: true },
    { name: 'Unpublished', value: false },
    { name: 'Both', value: 'both' }]
  constructor(private courseService: CourseService, private router: Router) { }

  ngOnInit() {
    this.getAllCourseWork();
  }

  getAllCourseWork() {
    this.loader = true;
    this.courseService.fetchAllCourseWork().pipe(finalize(() => {
      this.loader = false;
    })).subscribe(data => {
      this.allCourseWork = data.course_works;
      this.searchCourseWork('true');
    });
  }

  getPublish(value) {
    return value ? 'Publish' : 'Unpublised'
  }
  searchCourseWork(ev: any) {

    // set val to the value of the searchbar
    const val = ev.toLowerCase();
    // if the value is an empty string don't filter the items
    if (val && val.trim() != '') {
      this.isCourseWorkAvailable = true;
      this.courseWorkList = this.allCourseWork.filter((item) => {
        return ((item.course_work_title.toLowerCase().trim().indexOf(val.trim()) >= 0) || (item.publish.toString().indexOf(val) >= 0) || (ev == 'both' ? item : ''));
      });
    } else {
      this.isCourseWorkAvailable = false;
      this.courseWorkList = this.allCourseWork
    }
  }

  editSelectedCourseWork(coursework) {
    let courseWorkId = coursework.course_work_id;
    this.router.navigate(['/courses/add-course-work'], { queryParams: { courseWork: courseWorkId } });
  }

  onSelectAssessment(val) {
    this.searchCourseWork(val);
  }

  gotoViewCourseWork(course_work) {
    this.router.navigate(['/courses/coursework-info'], { queryParams: { view_course: 'view_course', course_work_id: course_work.course_work_id } });

  }
}
